import React from 'react'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import { BaseCard, CardField } from 'components'

export const CardVeiculo = (props) => {
  moment.locale('pt-br', localization)
  const { veiculo, handleClick } = props

  return (
    veiculo ? (
      <BaseCard
        avatar="VEICULO"
        title="Veículo"
        onClick={() => handleClick(veiculo.id)}
        onNovaAba={() => handleClick(veiculo.id, true)}
      >
        <CardField label="Identificador" value={veiculo.identificador} />
        <CardField label="Placa" value={veiculo.placa} />
        <CardField label="Marca" value={veiculo.marca} />
        <CardField label="Modelo" value={veiculo.modelo} />
        <CardField label="Data de entrada" value={moment(veiculo.createdAt).format('DD/MM/YYYY')} />
      </BaseCard>
    ) : null
  )
}
